// Smooth-scroll helper that works with Lenis (falls back to native)
export function scrollToId(target) {
  const offset = -72; // fixed header height
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(target, { offset, duration: 1.2 });
    return;
  }
  const el = document.querySelector(target);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset + offset, behavior: "smooth" });
}

export function scrollToTop() {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}
